'use client';
import { AnimatePresence, motion } from 'motion/react';
import React from 'react';

import styles from './block.module.scss';

type Props = {
  children: React.ReactNode;
};

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

export default function LogoGrid({ children }: Props) {
  return (
    <motion.div
      className={styles.grid}
      variants={containerVariants}
      initial='hidden'
      whileInView='visible'
      viewport={{ once: true }}
    >
      <AnimatePresence>{children}</AnimatePresence>
    </motion.div>
  );
}
